<div class="action-bar-layout__left">
  <ng-content select="[leftLayout]" />
</div>

<div class="action-bar-layout__center">
  <ng-content select="[centerLayout]" />
</div>

<div class="action-bar-layout__right">
  <ng-content select="[rightLayout]" />
</div>
